import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { ReactivateSelfExclusion } from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ReactivateSelfExclusion/ReactivateSelfExclusion';

interface SelfExclusionTabPropsType {
    customerId: number;
    permissionSelfExclusion: boolean;
}

export const SelfExclusionTab = observer(
    'SelfExclusionTab',
    ({ customerId, permissionSelfExclusion }: SelfExclusionTabPropsType) => {
        const { routerBackoffice } = useAppStateContext();

        return (
            <ReactivateSelfExclusion
                customerId={customerId}
                permissionSelfExclusion={permissionSelfExclusion}
                onAuditClick={(): void => {
                    routerBackoffice.setParamInNamespace('customers', 'audits', 'selfExclusionAudit');
                }}
            />
        );
    }
);
